// Position-related constants
export const POSITION_VALUES = {
  ALL: 'all',
  GOALKEEPER: 'Goalkeeper',
  DEFENDER: 'Defender',
  MIDFIELDER: 'Midfielder',
  FORWARD: 'Forward',
} as const;

// Position display names
export const POSITION_DISPLAY_NAMES = {
  [POSITION_VALUES.ALL]: 'All Positions',
  [POSITION_VALUES.GOALKEEPER]: 'Goalkeeper',
  [POSITION_VALUES.DEFENDER]: 'Defender',
  [POSITION_VALUES.MIDFIELDER]: 'Midfielder',
  [POSITION_VALUES.FORWARD]: 'Forward',
};

// Default position value
export const DEFAULT_POSITION = POSITION_VALUES.ALL;

export type PlayablePositionValue =
  | typeof POSITION_VALUES.GOALKEEPER
  | typeof POSITION_VALUES.DEFENDER
  | typeof POSITION_VALUES.MIDFIELDER
  | typeof POSITION_VALUES.FORWARD;
